import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { getAuth } from "../../utils";
import { type SharedWishlist, sharedWishlist } from "../schemas/sharedWishlist";

export const getSharedWishlistProps = z
  .object({
    token: z.string(),
  })
  .extend(requestConfig.shape);

export type GetSharedWishlistProps = z.infer<typeof getSharedWishlistProps>;

export const getSharedWishlist = async (
  args: GetSharedWishlistProps,
): Promise<SharedWishlist> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    auth: Authorization = getAuth(),
    token,
    proxyAuthSecret,
  } = parseServiceInput(getSharedWishlistProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(
    `${endpoint}/v3/wishlist/tag/anonymous/${token}`,
    {
      method: "GET",
      headers,
    },
  );

  return parseServiceOutput(response, sharedWishlist, {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed",
  });
};
